/* pp-portal-data.js — Première Peau Partner Portal: form schema, UI strings, i18n overrides.
   English lives inline as the fallback. PP_PORTAL_I18N[locale][key] overrides it.
   A missing key or a missing locale degrades silently to English — never to blank. */

(function (w) {
  'use strict';

  /* ---------------------------------------------------------------- UI chrome */
  var UI = {
    'ui.eyebrow':        'Première Peau — Partner Access',
    'ui.gate.title':     'This page is not listed.',
    'ui.gate.lede':      'Enter the access code from your invitation to open the wholesale onboarding file.',
    'ui.gate.ph':        'Access code',
    'ui.gate.cta':       'Enter',
    'ui.gate.err':       'That code is not recognised.',
    'ui.gate.foot':      'No code? Write to {email} with your company name and territory.',

    'ui.stage1':         'Stage 1 of 3 — Application',
    'ui.stage2':         'Stage 2 of 3 — Under review',
    'ui.stage3':         'Stage 3 of 3 — Packing list',
    'ui.apply.title':    'Wholesale onboarding',
    'ui.apply.lede':     'Six sections. Everything is saved in this browser as you go, so you can close the tab and come back. Nothing reaches us until you press Submit on the last screen.',
    'ui.back':           'Back',
    'ui.continue':       'Continue',
    'ui.submit':         'Submit application',
    'ui.count':          'Section {n} of {total}',
    'ui.required':       'Required',
    'ui.missing':        'Fill the {n} field(s) marked in red before continuing.',
    'ui.short':          'At least {n} characters. You are at {m}.',
    'ui.select':         'Select',
    'ui.other':          'Other',
    'ui.saved':          'Saved',
    'ui.savedAt':        'Saved {time}',
    'ui.review.title':   'Before you send',
    'ui.review.edit':    'Edit',
    'ui.reset':          'Clear this browser and start again',
    'ui.resetConfirm':   'This erases everything you have entered on this device. There is no undo. Continue?',
    'ui.print':          'Print this page',
    'ui.sending':        'Sending…',

    'ui.rev.title':      'Application received',
    'ui.rev.lede':       'We read every file by hand. While it is with us, the four below are the ones worth doing — they are what a first shipment ends up waiting on, and the week is otherwise dead time.',
    'ui.rev.ref':        'Your reference',
    'ui.rev.filed':      'Filed {date}',
    'ui.rev.window':     'We aim to come back within {n} business days',
    'ui.rev.elapsed':    'Business day {n} of {total}',
    'ui.rev.over':       'Past the window. Write to {email} quoting your reference.',
    'ui.rev.pipeline':   'What we are doing',
    'ui.rev.p1':         'Reading the file and the door list',
    'ui.rev.p2':         'Validating the tax identifier against the official register',
    'ui.rev.p3':         'Checking the territory against existing accounts',
    'ui.rev.p4':         'Confirming the regulatory route for your market',
    'ui.rev.p5':         'We write back by email',
    'ui.rev.progress':   '{done} of {total} tasks done',
    'ui.rev.open':       'Open',
    'ui.rev.todo':       'To do',
    'ui.rev.done':       'Done',
    'ui.rev.markDone':   'Mark this section done',
    'ui.rev.marked':     'Done — reopen',

    'ui.t1.title':       'Send the document pack',
    'ui.t1.body':        'Attach these to one email to {email}, subject line = your reference. Nothing here is unusual; every one of them is asked for by somebody downstream — your customs broker, your authority, our insurer. Send what you have and tell us what you do not.',
    'ui.t2.title':       'Know your regulatory route',
    'ui.t2.nocountry':   'Give us a country of registration in Stage 1 and the route appears here.',
    'ui.tr.dg':          'Dangerous goods',
    'ui.tr.class':       'Class',
    'ui.tr.pg':          'packing group',
    'ui.tr.air':         'By air',
    'ui.tr.sea':         'By sea',
    'ui.tr.lq':          'Limited quantity',
    'ui.tr.hs':          'HS code',
    'ui.tr.inco':        'Incoterms 2020 — what each one costs you',
    'ui.tr.docs':        'The export document set',
    'ui.tr.doc':         'Document',
    'ui.tr.who':         'Issued by',
    'ui.tr.when':        'When it is needed',
    'ui.t2.body':        'Cosmetics do not cross borders on goodwill. This is the route for the country you gave us, and the documents we can issue against it. Worth reading before you commit to an opening date with your stores.',
    'ui.t3.title':       'Build your opening assortment',
    'ui.t3.body':        'Draft it now and it is the sheet we work from when we come back to you. Full cases of {case} per reference and size, {moq} units minimum on an opening order. Testers are computed for you — one per {tOpen} units on an opening, one per {tRe} on a reassort — and are not a separate purchase.',
    'ui.t4.title':       'Plan the launch',
    'ui.t4.body':        'The accounts that sell this line are the ones that decided how, before the boxes arrived. Ten minutes here is worth more than any of the paperwork above.',

    'ui.plan.house':     'Reference',
    'ui.plan.size':      'Size',
    'ui.plan.sku':       'SKU',
    'ui.plan.units':     'Units',
    'ui.plan.cases':     'Cases',
    'ui.plan.testers':   'Testers',
    'ui.plan.total':     'Total',
    'ui.plan.totalUnits':'Units',
    'ui.plan.totalCases':'Cases',
    'ui.plan.totalRefs': 'References',
    'ui.plan.totalTest': 'Testers',
    'ui.plan.caseErr':   'Full cases of {case} only. Round {sku} to {up}.',
    'ui.plan.moqErr':    'Opening order minimum is {moq} units. You are at {n}.',
    'ui.plan.ok':        'The shape works. Quantities stay subject to what we can allocate.',
    'ui.plan.empty':     'Nothing drafted yet.',
    'ui.plan.orderType': 'Order type',
    'ui.plan.opening':   'Opening order',
    'ui.plan.reassort':  'Reassort',
    'ui.plan.note':      'Units only. Pricing sits on your order form, not here.',

    'ui.unlock.title':   'Have a code for the packing list?',
    'ui.unlock.body':    'We send one by email when we would like you to prepare the packing list.',
    'ui.unlock.ph':      'Packing list code',
    'ui.unlock.cta':     'Unlock',
    'ui.unlock.err':     'Not recognised. Check the email, or write to us quoting your reference.',

    'ui.pack.title':     'Confirm the packing list',
    'ui.pack.lede':      'This is the sheet a warehouse picks against and a broker clears against. Check every line — it is easier to fix here than on a pallet.',
    'ui.pack.lines':     'Lines',
    'ui.pack.ship':      'Ship to',
    'ui.pack.terms':     'Terms',
    'ui.pack.sign':      'Signature',
    'ui.pack.submit':    'Confirm packing list',
    'ui.pack.editPlan':  'Change the quantities',
    'ui.pack.warnEmpty': 'Draft an assortment before confirming.',

    'ui.done.title':     'Received',
    'ui.done.lede':      'Your packing list is with us. We come back by email, to the accounts payable address you gave.',
    'ui.done.next':      'There is nothing further to do here for now. If a line has to change, replying on the same thread keeps it in one place.',
    'ui.done.ref':       'Reference',

    /* ------------------------------------------------------------- accounts */
    'ui.gate.needAccount': 'Sign in first — the code alone is not enough at the moment.',
    'ui.acct.outTitle':  'A partner account',
    'ui.acct.outBody':   'An account keeps your file, your assortment and your documents in one place, and it is what opens the media library. It costs nothing and commits neither of us to anything.',
    'ui.acct.mediaTitle':'Sign in to open the library',
    'ui.acct.mediaBody': 'The films, the packshots and the documents sit behind a real sign-in rather than behind the access code, so a link cannot be forwarded out of your company by accident.',
    'ui.acct.how':       'We send a one-time code to your address — there is no password to invent or lose.',
    'ui.acct.create':    'Sign in or create an account',
    'ui.acct.inTitle':   'Signed in as {name}',
    'ui.acct.inPlain':   'Campaigns, packshots and brand files are open to you. The regulatory documents open once we have set your account up on our side.',
    'ui.acct.inPartner': 'Your account carries partner access, so the regulatory documents are open too.',
    'ui.acct.manage':    'Your account',
    'ui.acct.out':       'Sign out',

    /* ---------------------------------------------------------------- media */
    'ui.med.eyebrow':    'Première Peau — Media library',
    'ui.med.title':      'Media library',
    'ui.med.lede':       'Everything here already runs on premierepeau.com or already travels with the goods. Nothing is a mock-up. Every tile prints the real size and weight of the file, so you know before you download whether it will hold at the size you need.',
    'ui.med.open':       'Media library',
    'ui.med.back':       'Back to your file',
    'ui.med.off':        'The library is closed for the moment. Write to {email} and we will send what you need directly.',
    'ui.med.search':     'Search the library',
    'ui.med.count':      '{n} files',
    'ui.med.empty':      'Nothing under those filters.',
    'ui.med.allScents':  'All fragrances',
    'ui.med.allKinds':   'All kinds',
    'ui.med.get':        'Download',
    'ui.med.getting':    'Fetching…',
    'ui.med.copy':       'Copy link',
    'ui.med.copied':     'Copied',
    'ui.med.copyAll':    'Copy every link in view',
    'ui.med.saveList':   'Save the list',
    'ui.med.request':      'Request this sheet',
    'ui.med.reqWhy':       'We send the safety data sheets by hand rather than publishing them — they carry the full composition. Ask and it comes back the same day.',
    'ui.med.reqSubject':   'Safety data sheet — {doc}',
    'ui.med.reqBodyOpen':  'Hello,',
    'ui.med.reqBodyAsk':   'Please send us the safety data sheet for {doc}.',
    'ui.med.reqCompany':   'Company',
    'ui.med.reqCountry':   'Country',
    'ui.med.reqRef':       'Reference',
    'ui.med.reqNoRef':     '(no application filed yet)',
    'ui.med.reqWho':       'Contact',
    'ui.med.reqPurpose':   'What we need it for: customs clearance / local registration / our carrier / other —',
    'ui.med.reqBodyClose': 'Thank you.',
    'ui.med.openDoc':    'Open the document',
    'ui.med.close':      'Close',
    'ui.med.pages':      '{n} pages',
    'ui.med.page1':      '1 page',
    'ui.med.shotN':      'shot {n}',
    'ui.med.liveShot':   'The file the storefront itself serves, at its full width. What you publish will match what a customer sees.',
    'ui.med.ask':        'Need another crop, another language, a master file or a format that is not here? Ask at {email} — it usually exists.',
    'ui.med.lockTitle':  'The documents are not open on this account yet',
    'ui.med.lockBody':   'Safety data sheets and registration certificates open once we have set your account up on our side. The films, the packshots and the brand files are open to you now.',
    'ui.med.lockFoot':   'If you need a sheet today, ask at {email} and we will send it by return.',
    'ui.med.transport':  'Transport and customs',
    'ui.med.transportNote': 'Taken from the safety data sheets. Your broker will still classify against the rules of your own territory.',
    'ui.med.gtin':       'Barcodes',
    'ui.med.gtinNote':   'Read live from the product records. The 2 ml is a sampling format and does not appear on wholesale lines.',
    'ui.med.thProduct':  'Product',
    'ui.med.thSize':     'Size',
    'ui.med.thSku':      'SKU',
    'ui.med.thGtin':     'GTIN',

    /* ---- partner spaces (one password = one client space) ---- */
    'ui.gate.lede2':                 'Enter the password from your welcome email to open your space.',
    'ui.gate.ph2':                   'Your password',
    'ui.gate.err2':                  'Password not recognised.',
    'ui.gate.working':               'Opening…',
    'ui.space.eyebrow':              'Première Peau — Partner space',
    'ui.space.welcome':              'Welcome, {client}.',
    'ui.space.lede':                 'Your space while your first delivery is being prepared: the training module, the perfumer on film, the media library, the price guidance for {geo} and the documents that travel with the goods.',
    'ui.space.status':               'Delivery in preparation',
    'ui.space.order':                'Order {ref} · {date}',
    'ui.space.contact':              'Your contact at the house',
    'ui.space.close':                'Close this space',
    'ui.space.tab.home':             'Overview',
    'ui.space.tab.training':         'Training',
    'ui.space.tab.films':            'The perfumer',
    'ui.space.tab.media':            'Media library',
    'ui.space.tab.prices':           'Prices & guidelines',
    'ui.space.tab.docs':             'Documents',
    'ui.space.training.title':       'Training module',
    'ui.space.training.lede':        'Forty minutes, or ten per module. Written for the people who will stand at the counter: what sets the house apart, how to present each fragrance, how to answer the five objections that come up.',
    'ui.space.training.open':        'Open the module',
    'ui.space.training.print':       'Print or save as PDF',
    'ui.space.training.hint':        'The module opens inside this page. Use the sidebar to jump between parts.',
    'ui.space.films.title':          'Claire Liegent on film',
    'ui.space.films.lede':           'Claire Liegent composed four of the seven fragrances. Two films: sixty seconds on simplicity, and the long conversation with Pierre Mergui about Simili Mirage. Subtitles in {n} languages — choose yours in the CC menu of the player.',
    'ui.space.films.reel':           'Sixty seconds on simplicity',
    'ui.space.films.reelNote':       'Vertical format, made for a phone or a vertical screen in store. French audio.',
    'ui.space.films.long':           'The long conversation — Simili Mirage',
    'ui.space.films.longNote':       'Seven minutes. The sofa in the sun, the maquis, the leather, the liqueur. French audio.',
    'ui.space.films.subs':           'Subtitles',
    'ui.space.films.download':       'Download the file',
    'ui.space.prices.item':          'Item',
    'ui.space.prices.price':         'Price',
    'ui.space.prices.guidelines':    'Brand presentation',
    'ui.space.prices.compliance':    'Import and compliance',
    'ui.space.prices.marketplaces':  'Third-party marketplaces we ask you not to list on',
    'ui.space.docs.title':           'Documents',
    'ui.space.docs.lede':            'The documents that travel with the goods, and the ones your customs broker and your regulatory contact will ask for.',
    'ui.space.docs.cgv':             'Conditions of sale — authorised resellers (FR / EN)',
    'ui.space.docs.cgvNote':         'Three pages, bilingual. Version of 12 July 2026.',
    'ui.space.docs.fda':             'FDA facility registration',
    'ui.space.docs.sds':             'Safety data sheets',
    'ui.space.docs.sdsNote':         'One per fragrance, in the media library under INCI & co.',
    'ui.space.docs.training':        'Training module',
    'ui.space.home.next':            'What happens next',
    'ui.space.home.nextBody':        'Your order is being prepared. We write to you the day it leaves, with the carrier and the tracking number. Until then, this space is yours: train the team, choose the films and images you will use, read the price guidance for your market.',
    'ui.space.home.help':            'Anything missing? Write to {email} and quote your order number.',

    /* ---- shipping file: what a paid client gives us before we prepare the goods ---- */
    'ui.ship.eyebrow':      'Première Peau — Shipping file',
    'ui.ship.title':        'Before we prepare your shipment',
    'ui.ship.lede':         'Your order is confirmed. What the warehouse, the carrier, your customs broker and your authority need is below: nine sections, around forty minutes with the answers to hand. Everything is saved in this browser as you go. Nothing leaves your side until you press Send on the last screen, and once sent the file is closed for editing. The rest of your space opens once it is filed.',
    'ui.ship.order':        'Order {ref} · {date}',
    'ui.ship.submit':       'Send the shipping file',
    'ui.ship.review.title': 'Before you send',
    'ui.ship.review.lede':  'Read it once more as the person who will unload the pallet. This is the version we prepare against, and it cannot be edited once sent.',
    'ui.ship.rev.title':    'We are reviewing your shipping file',
    'ui.ship.rev.lede':     'Every file is checked by hand against the order, the regulatory route and the documents your territory asks for. We will be back to you within {n} business days, by email, to the logistics contact you gave. Until then there is nothing further to send. Your space is open: train the team, choose the films and images, read the guidance for your market.',
    'ui.ship.rev.ref':      'Shipping file reference',
    'ui.ship.rev.filed':    'Filed {date}',
    'ui.ship.rev.window':   'We will be back to you within {n} business days',
    'ui.ship.rev.elapsed':  'Business day {n} of {total}',
    'ui.ship.rev.over':     'Past the window. Write to {email} quoting the reference.',
    'ui.ship.rev.what':     'What we are checking',
    'ui.ship.rev.p1':       'The consignee against the order and the invoice',
    'ui.ship.rev.p2':       'The delivery site against the carrier\'s constraints',
    'ui.ship.rev.p3':       'The regulatory route and the labelling block',
    'ui.ship.rev.p4':       'The document set your broker asked for',
    'ui.ship.rev.p5':       'We write back by email'
  };

  /* ------------------------------------------------------------- form schema */
  /* type: text | email | tel | url | number | textarea | select | country | check
     labelFrom: 'taxLabel' pulls the label from the selected country row.           */
  var SCHEMA = [
    {
      id: 'identity',
      nav: 'Identity',
      title: 'Legal identity',
      note: 'This is what goes on the proforma and on the customs paperwork. Use the registered entity, not the shop sign.',
      fields: [
        { k:'legal_name', type:'text', wide:true, req:true, label:'Registered legal entity', ac:'organization' },
        { k:'trading_name', type:'text', label:'Trading or store name' },
        { k:'country', type:'country', req:true, label:'Country of registration' },
        { k:'reg_no', type:'text', req:true, label:'Company registration number', ph:'SIREN / CR / EIN / UEN / ABN' },
        { k:'tax_id', type:'text', label:'VAT or tax identifier', labelFrom:'taxLabel', hintFrom:'taxHint',
          hint:'EU buyers: without a number that validates in VIES on the invoice date we cannot zero-rate the shipment. The VAT is charged, and it is not recoverable afterwards.' },
        { k:'eori', type:'text', label:'EORI or importer number', hint:'Whatever your customs authority issues you to import under.' },
        { k:'reg_address', type:'textarea', wide:true, req:true, label:'Registered address', ph:'Street, postcode, city' },
        { k:'website', type:'url', label:'Website', ph:'https://' },
        { k:'founded', type:'text', label:'Year founded', num:true }
      ]
    },
    {
      id: 'footprint',
      nav: 'Footprint',
      title: 'Retail footprint',
      note: 'We check doors as we read the file. List the ones that will actually carry the line — a door you cannot open is worse for both of us than a door you never claimed.',
      fields: [
        { k:'account_type', type:'select', req:true, label:'Account type', opts:[
          'Independent perfumery — single door',
          'Independent perfumery — multi-door',
          'Department store or concession',
          'Concept and lifestyle store',
          'Pure-play e-commerce',
          'Distributor or importer',
          'Travel retail and duty free',
          'Hotel, spa or members club'
        ]},
        { k:'door_count', type:'number', req:true, label:'Doors that will carry the line', min:0 },
        { k:'door_list', type:'textarea', wide:true, req:true, rows:5, label:'Door list',
          ph:'One per line — store name, city, country',
          hint:'One per line. If you are a distributor, list the doors you will place into, not your own warehouse.' },
        { k:'brands_carried', type:'textarea', wide:true, req:true, rows:4, label:'Niche houses you already carry', ph:'Comma separated' },
        { k:'marketplaces', type:'select', label:'Do you sell on marketplaces?', opts:[
          'No', 'Yes — but this line would not go there', 'Yes — including fragrance'
        ], hint:'Amazon, eBay, Noon, Tmall, Fruugo, Catch, Zalando and equivalents. Saying yes is not a rejection. Not saying it is.' },
        { k:'footprint_notes', type:'textarea', wide:true, rows:3, label:'Anything about the doors we should know',
          ph:'Refits, openings, seasonality, a door that is closing' }
      ]
    },
    {
      id: 'territory',
      nav: 'Territory',
      title: 'Territory and logistics',
      note: 'Accounts start non-exclusive. Where exclusivity comes later it is written, dated, tied to a volume and looked at again each year.',
      fields: [
        { k:'territory', type:'textarea', wide:true, req:true, rows:2, label:'Territory requested',
          ph:'Countries, or a named region' },
        { k:'incoterm', type:'select', req:true, label:'Incoterm', optsFrom:'incoterms' },
        { k:'forwarder', type:'text', label:'Freight forwarder' },
        { k:'forwarder_account', type:'text', label:'Forwarder account number',
          hint:'On EXW and FCA this is how the goods leave the building. Without it nothing moves.' },
        { k:'freight_mode', type:'select', label:'Air, sea or road', opts:[
          'Air — dangerous goods declaration in place',
          'Air — no DG capability yet',
          'Sea — LCL', 'Sea — FCL', 'Road', 'To be advised'
        ]},
        { k:'ship_address', type:'textarea', wide:true, req:true, rows:3, label:'Delivery address', ph:'Street, postcode, city' },
        { k:'ship_country', type:'country', req:true, label:'Delivery country',
          hint:'Picked from the list, not typed. A country field that disagrees with the address sends the pallet to the wrong continent. It has happened.' },
        { k:'receiving_hours', type:'text', label:'Receiving hours', ph:'Mon–Fri 09:00–16:00, appointment required' },
        { k:'currency', type:'select', label:'Invoicing currency', opts:[
          'EUR', 'USD', 'GBP', 'CHF', 'AED', 'SAR', 'JPY', 'KRW', 'SGD', 'HKD', 'AUD', 'CAD', 'Other — noted below'
        ]},
        { k:'payment_terms', type:'select', label:'Payment terms requested', opts:[
          '100% before dispatch', '50% on order, 50% before dispatch',
          'Net 30 from dispatch', 'Net 60 from dispatch', 'Letter of credit', 'Documentary collection'
        ], hint:'Opening orders normally ship on prepayment. Terms tend to open on the second order, once there is a record.' }
      ]
    },
    {
      id: 'compliance',
      nav: 'Compliance',
      title: 'Regulatory and import',
      note: 'Tell us where you stand and we issue the dossier your authority asks for — safety assessment, allergen statement, free sale certificate, artwork in your labelling language. Pick the country first and the route below fills itself in.',
      regime: true,
      fields: [
        { k:'rp_who', type:'select', req:true, label:'Who is the responsible person or importer of record?', opts:[
          'We are — already appointed and registered',
          'We are — not yet appointed',
          'A third party we retain',
          'We need guidance'
        ]},
        { k:'rp_entity', type:'text', label:'Responsible person entity' },
        { k:'reg_status', type:'textarea', wide:true, req:true, rows:3, label:'Registration status in your territory',
          ph:'Notified / filed / in progress / not started — and under which scheme' },
        { k:'labelling', type:'textarea', wide:true, rows:3, label:'Labelling requirements',
          ph:'Languages required on the outer, local importer block, ingredient list format, any mandatory symbol' },
        { k:'alcohol_licence', type:'select', label:'Alcohol or DG import licence', opts:[
          'Not required in our territory', 'Held', 'In application', 'Not held'
        ], hint:'Extrait de parfum travels as UN1266, class 3. Some territories gate it, some gate only the air leg.' },
        { k:'docs_needed', type:'textarea', wide:true, rows:3, label:'Documents you will need from us',
          ph:'Tick them in Stage 2 — this box is for anything the list does not cover' }
      ]
    },
    {
      id: 'contacts',
      nav: 'Contacts',
      title: 'Who we deal with',
      note: 'Three different people, usually. Give us all three now and no invoice goes missing later.',
      fields: [
        { k:'buyer_name', type:'text', req:true, label:'Buying contact — name', ac:'name' },
        { k:'buyer_email', type:'email', req:true, label:'Buying contact — email', ac:'email' },
        { k:'buyer_phone', type:'tel', label:'Buying contact — phone', ac:'tel', dial:true },
        { k:'buyer_role', type:'text', label:'Buying contact — role' },
        { k:'logi_name', type:'text', label:'Logistics contact — name' },
        { k:'logi_email', type:'email', label:'Logistics contact — email' },
        { k:'ap_email', type:'email', req:true, label:'Accounts payable — email',
          hint:'Invoices go here and nowhere else.' },
        { k:'language', type:'select', label:'Correspondence language', opts:[
          'English', 'Français', 'Deutsch', 'Español', 'Italiano', 'Nederlands', '日本語', '한국어', 'العربية', 'Other'
        ]},
        { k:'source', type:'textarea', wide:true, rows:2, label:'How did you come to us?',
          ph:'A trade show, a stockist, a buyer, a search' }
      ]
    },
    {
      id: 'terms',
      nav: 'Terms',
      title: 'Trading conditions',
      note: 'Read them. They are short because they are the ones we actually enforce.',
      terms: [
        { k:'ack_map', title:'Recommended retail price',
          body:'We have the recommended retail price for our market. It is a recommendation. We set our own resale prices, and nothing in this file obliges us to follow it.' },
        { k:'ack_exclusivity', title:'Non-exclusive',
          body:'Accounts are non-exclusive: no reserved territory, no protected door. Any exclusivity agreed later is written, dated and tied to a volume.' },
        { k:'ack_channel', title:'Selective distribution',
          body:'The line is distributed selectively. We sell it only through the doors and the online store we listed, we do not resell to traders outside the network, and we do not list it on third-party marketplaces or auction sites. Customers who come to us of their own accord we are free to serve, wherever they are.' },
        { k:'ack_moq', title:'Order shape',
          body:'Orders go in full cases of {case} per reference and size, {moq} units minimum on an opening order. Testers come on the published ratio and are not invoiced separately.' },
        { k:'ack_integrity', title:'Batch traceability',
          body:'The batch code is what ties a bottle to its safety file and to any recall. Repackaging, decanting or relabelling breaks that link, so the sleeve, the code and the bottle travel together.' },
        { k:'ack_data', title:'Data',
          body:'These contacts run the account — orders, invoices, shipping documents, recalls. Write in at any time to correct or erase them.' },
        { k:'ack_truth', title:'Accuracy',
          body:'The above is accurate today, and we will say so if something material changes — a door that closes, a tax number that lapses, a channel we take on.' }
      ],
      fields: [
        { k:'notes', type:'textarea', wide:true, rows:4, label:'Anything else', ph:'Free text' }
      ]
    }
  ];

  /* ------------------------------------------ shipping file (paid client space) */
  /* Same field grammar as SCHEMA. Translation keys: sh.<id>.*, sf.<k>.*, st.<k>.*.
     reqIf: { k, v } makes a field required when another field holds that value.   */
  var SHIP = [
    {
      id: 'consignee',
      nav: 'Consignee',
      title: 'Consignee and importer',
      note: 'What goes on the commercial invoice, the packing list and the airway bill. Once the documents are issued, a change here means every one of them is issued again.',
      fields: [
        { k:'legal_name', type:'text', wide:true, req:true, label:'Consignee — legal entity', ac:'organization', hint:'Exactly as it must read on the invoice and the airway bill. Not the shop sign.' },
        { k:'trading_name', type:'text', label:'Trading or store name' },
        { k:'country', type:'country', req:true, label:'Country of registration' },
        { k:'reg_no', type:'text', req:true, label:'Company registration number', ph:'SIREN / CR / EIN / UEN / ABN' },
        { k:'tax_id', type:'text', req:true, label:'VAT or tax identifier', labelFrom:'taxLabel', hintFrom:'taxHint',
          hint:'The number printed on the invoice. EU buyers: it has to validate in VIES on the invoice date or the VAT is charged. Write “none” if your territory issues none.' },
        { k:'eori', type:'text', req:true, label:'EORI or importer number', hint:'Whatever your customs authority issues you to import under. Write “none” if there is none.' },
        { k:'reg_address', type:'textarea', wide:true, req:true, rows:3, label:'Registered address', ph:'Street, postcode, city' },
        { k:'legal_rep', type:'text', req:true, label:'Legal representative — full name' },
        { k:'importer_same', type:'select', req:true, label:'Who is the importer of record?', opts:[
          'The consignee above', 'Another entity — details below'
        ]},
        { k:'importer_entity', type:'text', label:'Importer of record — legal entity', reqIf:{ k:'importer_same', v:'Another entity — details below' } },
        { k:'importer_address', type:'textarea', wide:true, rows:2, label:'Importer of record — address', reqIf:{ k:'importer_same', v:'Another entity — details below' } },
        { k:'importer_tax', type:'text', label:'Importer of record — tax and importer numbers', reqIf:{ k:'importer_same', v:'Another entity — details below' } }
      ]
    },
    {
      id: 'site',
      nav: 'Delivery site',
      title: 'Where the goods arrive',
      note: 'A carrier books against this. What is missing here is what turns a delivery into a redelivery.',
      fields: [
        { k:'ship_address', type:'textarea', wide:true, req:true, rows:3, label:'Delivery address', ph:'Street, postcode, city' },
        { k:'ship_country', type:'country', req:true, label:'Delivery country',
          hint:'Picked from the list, not typed. A country that disagrees with the address sends the pallet to the wrong continent. It has happened.' },
        { k:'site_type', type:'select', req:true, label:'Type of site', opts:[
          'The store itself', 'Our own warehouse', 'A third-party warehouse or 3PL', 'Our forwarder\'s depot', 'An office'
        ]},
        { k:'site_contact', type:'text', req:true, label:'Site contact on delivery — name' },
        { k:'site_phone', type:'tel', req:true, label:'Site contact — phone', dial:true, hint:'A number that is answered on the day. The driver calls it.' },
        { k:'site_email', type:'email', req:true, label:'Site contact — email' },
        { k:'receiving_hours', type:'text', req:true, label:'Receiving hours', ph:'Mon–Fri 09:00–16:00' },
        { k:'appointment', type:'select', req:true, label:'Delivery appointment', opts:[
          'Not required', 'Required — by phone', 'Required — by email', 'Required — through a booking portal (details below)'
        ]},
        { k:'access', type:'select', req:true, label:'Unloading', opts:[
          'Loading dock', 'Ground level, no dock', 'Kerbside only', 'Stairs or lift to reach the stockroom'
        ]},
        { k:'tail_lift', type:'select', req:true, label:'Tail lift', opts:[ 'Needed', 'Not needed' ] },
        { k:'pallets', type:'select', req:true, label:'Pallets', opts:[
          'Pallets accepted', 'Cartons only — hand unload', 'Pallets accepted, no forklift on site'
        ]},
        { k:'vehicle_limit', type:'text', label:'Vehicle restrictions', ph:'Maximum length or height, pedestrian zone, time window' },
        { k:'id_required', type:'select', req:true, label:'Driver registration or ID at the gate', opts:[ 'No', 'Yes — details below' ] },
        { k:'site_notes', type:'textarea', wide:true, rows:3, label:'Anything the driver has to know', ph:'Entrance, gate code, security desk, where to park' }
      ]
    },
    {
      id: 'split',
      nav: 'Split',
      title: 'One delivery or several',
      note: 'If the goods go to more than one place we pick and label per destination. Tell us now, not when the pallet is wrapped.',
      fields: [
        { k:'split', type:'select', req:true, label:'How the order is delivered', opts:[
          'One address — the site above', 'Several addresses — listed below'
        ]},
        { k:'split_list', type:'textarea', wide:true, rows:5, label:'Destinations', reqIf:{ k:'split', v:'Several addresses — listed below' },
          ph:'One per line — store name, full address, contact, phone, what goes there',
          hint:'One line per destination with what it receives, by reference and size. We split the packing list on this.' },
        { k:'testers_where', type:'textarea', wide:true, req:true, rows:2, label:'Where the testers go', ph:'Which door, which counter' },
        { k:'split_notes', type:'textarea', wide:true, rows:2, label:'Anything about the split', ph:'A door opening later, a destination to hold back' }
      ]
    },
    {
      id: 'transport',
      nav: 'Transport',
      title: 'Transport and customs',
      note: 'Extrait de parfum travels as UN1266, class 3. Whoever moves it and whoever clears it has to know that before the booking, not at the airport.',
      regime: false,
      fields: [
        { k:'incoterm', type:'select', req:true, label:'Incoterm', optsFrom:'incoterms' },
        { k:'freight_mode', type:'select', req:true, label:'Air, sea or road', opts:[
          'Air — dangerous goods declaration in place', 'Air — no DG capability yet', 'Sea — LCL', 'Sea — FCL', 'Road', 'To be advised'
        ]},
        { k:'forwarder', type:'text', label:'Freight forwarder', hint:'On EXW and FCA this is how the goods leave the building.' },
        { k:'forwarder_account', type:'text', label:'Forwarder account number' },
        { k:'forwarder_contact', type:'text', label:'Forwarder — contact name, email, phone' },
        { k:'broker', type:'text', req:true, label:'Customs broker', hint:'Name and city. Write “none yet” if you do not have one; we will say what that means for your route.' },
        { k:'broker_contact', type:'text', label:'Broker — contact name, email, phone' },
        { k:'dg_ok', type:'select', req:true, label:'Dangerous goods', opts:[
          'Our forwarder handles UN1266 class 3 by air', 'Sea or road only — no air DG', 'We do not know yet'
        ]},
        { k:'licence', type:'select', req:true, label:'Alcohol, perfume or DG import licence', opts:[
          'Not required in our territory', 'Held — number below', 'In application', 'Not held'
        ]},
        { k:'licence_no', type:'text', label:'Licence number and issuing authority', reqIf:{ k:'licence', v:'Held — number below' } },
        { k:'insurance', type:'select', req:true, label:'Transit insurance', opts:[
          'Our forwarder insures', 'We insure under our own policy', 'Covered by the Incoterm we chose', 'We would like the house to arrange it'
        ]},
        { k:'pre_inspection', type:'select', req:true, label:'Pre-shipment inspection or legalisation', opts:[
          'None required', 'Required — details below'
        ]},
        { k:'inspection_notes', type:'textarea', wide:true, rows:2, label:'Inspection or legalisation details', reqIf:{ k:'pre_inspection', v:'Required — details below' }, ph:'Which body, which documents, who pays the fee' },
        { k:'routing_notes', type:'textarea', wide:true, rows:2, label:'Routing or handling instructions', ph:'Preferred airport or port, no transhipment via, temperature, anything your broker insists on' }
      ]
    },
    {
      id: 'regulatory',
      nav: 'Regulatory',
      title: 'Regulatory and labelling',
      note: 'Pick the country of registration in section 1 and the route for your market appears below. Then tell us exactly what has to be printed for your territory — we print it, once, before the goods leave.',
      regime: true,
      fields: [
        { k:'rp_who', type:'select', req:true, label:'Responsible person or local registrant', opts:[
          'We are — already appointed and registered', 'We are — not yet appointed', 'A third party we retain', 'We need guidance'
        ]},
        { k:'rp_entity', type:'text', label:'Responsible person — legal entity', reqIf:{ k:'rp_who', v:'A third party we retain' } },
        { k:'rp_address', type:'textarea', wide:true, rows:2, label:'Responsible person — address as it must be printed', reqIf:{ k:'rp_who', v:'A third party we retain' } },
        { k:'reg_status', type:'textarea', wide:true, req:true, rows:3, label:'Registration or notification status',
          ph:'Notified / filed / in progress / not started — under which scheme, and the reference numbers you already hold' },
        { k:'label_lang', type:'text', req:true, label:'Languages required on the outer' },
        { k:'importer_block', type:'textarea', wide:true, req:true, rows:3, label:'Importer block to print — exact text',
          ph:'Name, address, phone or email as your authority requires it. Write “not required” if none.' },
        { k:'extra_symbols', type:'textarea', wide:true, rows:2, label:'Mandatory symbols, warnings or numbers', ph:'Recycling marks, batch format, registration number, a local hotline' },
        { k:'ingredient_format', type:'select', req:true, label:'Ingredient list', opts:[
          'As printed on the EU outer', 'Local format — details below', 'Not required on the outer'
        ]},
        { k:'reg_notes', type:'textarea', wide:true, rows:2, label:'Anything else your authority asks for', ph:'Free text' }
      ]
    },
    {
      id: 'documents',
      nav: 'Documents',
      title: 'Documents for the shipment',
      note: 'Tick what your broker and your authority need from us, and tell us what the invoice has to show. A document asked for after the goods have left costs a week.',
      fields: [
        { k:'doc_coa', type:'check', wide:true, label:'Certificate of analysis, per batch' },
        { k:'doc_sds', type:'check', wide:true, label:'Safety data sheets' },
        { k:'doc_fsc', type:'check', wide:true, label:'Certificate of free sale' },
        { k:'doc_cpsr', type:'check', wide:true, label:'Safety assessment summary' },
        { k:'doc_allergen', type:'check', wide:true, label:'Allergen statement' },
        { k:'doc_coo', type:'check', wide:true, label:'Certificate of origin' },
        { k:'doc_eur1', type:'check', wide:true, label:'EUR.1 or origin declaration on the invoice' },
        { k:'doc_legalised', type:'check', wide:true, label:'Chamber of commerce legalisation of the invoice' },
        { k:'doc_inci', type:'check', wide:true, label:'Full INCI list per fragrance' },
        { k:'po_number', type:'text', req:true, label:'Your purchase order number', hint:'Printed on the invoice and the outers. Write “none” if you do not use one.' },
        { k:'invoice_show', type:'textarea', wide:true, req:true, rows:3, label:'What the invoice must show',
          ph:'Your tax identifier, the HS code, an origin statement, a wording your customs insists on' },
        { k:'doc_lang', type:'select', req:true, label:'Language of the documents', opts:[ 'English', 'French', 'English and French', 'Other — noted below' ] },
        { k:'doc_email', type:'email', req:true, label:'Where document copies go before the goods move', hint:'Usually your broker. Copies go there and to the logistics contact.' },
        { k:'originals', type:'select', req:true, label:'Originals', opts:[
          'Scans are enough', 'Originals travel with the goods', 'Originals by courier before the goods'
        ]},
        { k:'packing_format', type:'textarea', wide:true, rows:2, label:'Packing list format your broker requires', ph:'Per carton, per pallet, gross and net weight, dimensions' },
        { k:'case_marks', type:'textarea', wide:true, rows:2, label:'Marks to print on the outers', ph:'PO number, store code, anything your warehouse scans' },
        { k:'doc_notes', type:'textarea', wide:true, rows:2, label:'Anything else about the paperwork', ph:'Free text' }
      ]
    },
    {
      id: 'readiness',
      nav: 'Readiness',
      title: 'Retail readiness',
      note: 'The goods arrive once. What happens in the first week decides the second order.',
      fields: [
        { k:'doors_receiving', type:'textarea', wide:true, req:true, rows:4, label:'Doors that receive stock from this order', ph:'One per line — store name, city' },
        { k:'on_shelf', type:'text', req:true, label:'Your target month on shelf', ph:'Month and year', hint:'Your plan, not a delivery date. It tells us how to sequence the paperwork.' },
        { k:'staff_training', type:'select', req:true, label:'Staff training', opts:[
          'A session with the house before the goods arrive', 'The module in this space, run by us', 'Already done'
        ]},
        { k:'pos_material', type:'select', req:true, label:'Counter material', opts:[
          'Needed — tester stands and cards', 'Not needed', 'Undecided'
        ]},
        { k:'imagery_lang', type:'text', label:'Language for copy and imagery' },
        { k:'tester_handling', type:'textarea', wide:true, req:true, rows:2, minLen:40, label:'How testers are handled on the counter', ph:'Who tops up, where they sit, what happens when one empties' },
        { k:'launch_notes', type:'textarea', wide:true, rows:3, label:'What you will do in the first month', ph:'Window, newsletter, an event, nothing at all — all valid answers' }
      ]
    },
    {
      id: 'contacts',
      nav: 'Contacts',
      title: 'Contacts for this shipment',
      note: 'Five different people, usually. Give us all five and the goods do not wait on a voicemail.',
      fields: [
        { k:'logi_name', type:'text', req:true, label:'Logistics contact — name' },
        { k:'logi_email', type:'email', req:true, label:'Logistics contact — email', hint:'Dispatch notice, carrier and tracking go here.' },
        { k:'logi_phone', type:'tel', req:true, label:'Logistics contact — phone', dial:true },
        { k:'customs_name', type:'text', req:true, label:'Customs contact — name', hint:'Your broker, or whoever answers customs the day the goods land.' },
        { k:'customs_email', type:'email', req:true, label:'Customs contact — email' },
        { k:'reg_name', type:'text', label:'Regulatory contact — name', hint:'Who receives the safety file and any recall notice. Leave blank if it is the logistics contact.' },
        { k:'reg_email', type:'email', label:'Regulatory contact — email' },
        { k:'ap_email', type:'email', req:true, label:'Accounts payable — email', hint:'The invoice goes here and nowhere else.' },
        { k:'delivery_phone', type:'tel', req:true, label:'Phone answered on delivery day', dial:true },
        { k:'whatsapp', type:'text', label:'WhatsApp number for the carrier, if different' },
        { k:'language', type:'select', req:true, label:'Correspondence language', opts:[
          'English', 'Français', 'Deutsch', 'Español', 'Italiano', 'Nederlands', '日本語', '한국어', 'العربية', 'Other'
        ]}
      ]
    },
    {
      id: 'declaration',
      nav: 'Declaration',
      title: 'Declaration',
      note: 'Read them. Then sign by typing your name — that is the signature we prepare the shipment against.',
      terms: [
        { k:'ack_consignee', title:'Consignee',
          body:'The consignee, the addresses and the numbers above are exactly what must appear on the documents. If any of it changes after the documents are issued, we understand they are issued again and the goods wait.' },
        { k:'ack_dg', title:'Dangerous goods',
          body:'The goods travel as UN1266, class 3. Our forwarder and our broker know it, and whoever we named can handle it on the mode we chose.' },
        { k:'ack_licence', title:'Import authorisation',
          body:'We hold what our territory requires to import perfume containing alcohol, or we have said above that we do not.' },
        { k:'ack_integrity', title:'Batch traceability',
          body:'The sleeve, the batch code and the bottle travel together. Nothing is repackaged, decanted or relabelled beyond the importer block we gave above.' },
        { k:'ack_site', title:'Delivery site',
          body:'The site can receive the goods as described. A delivery that fails for a reason on our side goes out again at our charge.' },
        { k:'ack_docs', title:'Documents',
          body:'We will send by email, quoting the reference, whatever we hold that the route requires — licence, appointment of the responsible person, notification receipts.' },
        { k:'ack_review', title:'Review',
          body:'We understand the file is checked by hand and that the reply comes by email within the window shown once it is filed.' },
        { k:'ack_truth', title:'Accuracy',
          body:'The above is accurate today, and we will write in the same day if something changes before the goods leave.' },
        { k:'ack_reviewed', title:'Re-read',
          body:'We have re-read every section below before signing. What is written there is what we are filing.' }
      ],
      fields: [
        { k:'sig_name', type:'text', req:true, label:'Signed — full name', hint:'Typed in full. This is the signature on the file.' },
        { k:'sig_role', type:'text', req:true, label:'Signed — title' },
        { k:'sig_place', type:'text', req:true, label:'Signed — city' },
        { k:'notes', type:'textarea', wide:true, rows:3, label:'Anything else', ph:'Free text' }
      ]
    }
  ];

  /* --------------------------------------------------- Stage 2 document pack */
  var DOCS = [
    { k:'d_reg',      name:'Certificate of incorporation or trade register extract', meta:'Proves the entity on the invoice exists.' },
    { k:'d_tax',      name:'VAT or tax registration certificate',                   meta:'The document behind the number you gave us.' },
    { k:'d_id',       name:'Photo ID of the signatory',                             meta:'Whoever signs the order form.' },
    { k:'d_bank',     name:'Bank details on company letterhead',                    meta:'On letterhead please — bank details typed into an email body are too easy to forge.' },
    { k:'d_refs',     name:'Two trade references',                                  meta:'Other houses you buy from. Name, contact, how long.' },
    { k:'d_photos',   name:'Photographs of the doors',                              meta:'Shopfront and interior. Phone photos are fine.' },
    { k:'d_licence',  name:'Import or cosmetic licence, where your territory issues one', meta:'Skip if your territory does not.' },
    { k:'d_forwarder',name:'Freight forwarder details and account number',          meta:'Only if you are collecting EXW or FCA.' },
    { k:'d_rp',       name:'Responsible person appointment, where required',        meta:'The letter naming who is legally established locally.' }
  ];

  /* ------------------------------------------------------ Stage 2 launch plan */
  var LAUNCH = [
    { k:'l_date',  type:'text',     label:'Target date on shelf', ph:'Month and year is enough' },
    { k:'l_where', type:'textarea', rows:3, label:'Where the line sits in the store', ph:'Which wall, which fixture, next to whom' },
    { k:'l_staff', type:'select',   label:'Staff training', opts:[
      'We want a session with the house', 'Send materials, we will run it', 'Already covered' ] },
    { k:'l_disco', type:'select',   label:'Discovery sets on counter', opts:[
      'Yes — as a paid try-before', 'Yes — as a gift with purchase', 'No', 'Undecided' ] },
    { k:'l_market',type:'textarea', rows:3, label:'What you will do in the first 60 days',
      ph:'Window, newsletter, an event, a local editor, nothing at all — all valid answers' },
    { k:'l_help',  type:'textarea', rows:3, label:'What you need from us', ph:'Assets, testers, copy in your language, a founder call' }
  ];

  /* --------------------------------------------------- Stage 3 packing fields */
  var PACK = [
    { k:'pk_consignee', type:'text',     req:true, wide:true, label:'Consignee — exactly as it must read on the airway bill' },
    { k:'pk_address',   type:'textarea', req:true, wide:true, rows:3, label:'Delivery address' },
    { k:'pk_country',   type:'country',  req:true, label:'Delivery country' },
    { k:'pk_contact',   type:'text',     req:true, label:'Site contact on delivery' },
    { k:'pk_phone',     type:'tel',      req:true, label:'Site contact phone', dial:true },
    { k:'pk_incoterm',  type:'select',   req:true, label:'Incoterm', optsFrom:'incoterms' },
    { k:'pk_forwarder', type:'text',     label:'Forwarder and account number' },
    { k:'pk_marks',     type:'textarea', wide:true, rows:2, label:'Case marks or PO number to print', ph:'Anything your warehouse needs to see on the outer' },
    { k:'pk_special',   type:'textarea', wide:true, rows:2, label:'Special instructions', ph:'Booking required, tail lift, no pallets, delivery window' },
    { k:'sign_name',    type:'text',     req:true, label:'Signatory — full name' },
    { k:'sign_role',    type:'text',     req:true, label:'Signatory — title' }
  ];

  w.PP_PORTAL_SCHEMA = { UI: UI, SCHEMA: SCHEMA, SHIP: SHIP, DOCS: DOCS, LAUNCH: LAUNCH, PACK: PACK };
  w.PP_PORTAL_I18N = w.PP_PORTAL_I18N || {};
})(window);
